import { Component, TemplateRef, ViewChild, ViewContainerRef, EmbeddedViewRef } from '@angular/core';

@Component({
  selector: 'chart-tooltip',
  template:
    `<ng-template #contentRef>
      <ng-content></ng-content>
    </ng-template>`,
})
export class ChartTooltipComponent {
  @ViewChild('contentRef', { static: true }) contentRef!: TemplateRef<any>;

  constructor(private viewContainerRef: ViewContainerRef) {}

  public ngAfterViewInit(): void {
    const embeddedViewRef: EmbeddedViewRef<any> = this.viewContainerRef.createEmbeddedView(this.contentRef);
    document.body.appendChild(embeddedViewRef.rootNodes[0]);
  }
}
